<div class="flip-card" [class.flipped]="videoFeedsFlipped">
  <div class="flip-card-inner">
    <!-- Front Side -->
    <div class="flip-card-front">
      <div class="box-header">
        <div class="d-flex align-items-center">
          <i class="fa fa-bars" aria-hidden="true"></i>
        </div>
        <p class="assets-header">{{'DASHBOARD.HEADER_TEXT' | translate}}</p>
        <mat-icon class="flip-icon" (click)="flipVideoFeeds()">map</mat-icon>
      </div>
      <div class="assets-section">
        <app-video-feeds class="video-feed-box" *ngIf="!isThermal"></app-video-feeds>
        <app-thermal-feeds class="video-feed-box" [alarmId]="selectedAlarmId" *ngIf="isThermal"></app-thermal-feeds>
      </div>
    </div>
    <!-- Back Side -->
    <div class="flip-card-back">
      <div class="box-header">
        <div class="d-flex align-items-center">
          <i class="fa fa-map-o" aria-hidden="true"></i>
        </div>
        <p class="assets-header">{{ "ANALYTICAL_ALARM_HISTORY.Map" | translate }}</p>
        <mat-icon class="flip-icon" (click)="flipVideoFeeds()">ondemand_video</mat-icon>
      </div>
      <div class="assets-section">
        <app-map class="video-feed-box"></app-map>
      </div>
    </div>
  </div>
</div>